import { createSlice } from '@reduxjs/toolkit';

const mavisSlice = createSlice({
  name: 'mavisSlice',
  initialState: {
    data: [],
    displayLoader: true,
    isDataLoaded: false
  },
  reducers: {
    handleData: (state, action) => {
      state.data = action.payload;
    },
    handleDisplayLoader: (state, action) => {
      state.displayLoader = action.payload;
    },
    handleIsDataLoaded: (state, action) => {
      state.isDataLoaded = action.payload;
    }
  }
});

export const { handleData, handleIsLoaded, handleDisplayLoader, handleIsDataLoaded } = mavisSlice.actions;

export default mavisSlice.reducer;
